import { connect, ConnectedProps } from "react-redux";
import { AppState } from "../../../../interfaces";
import { API_KEYS } from "../../../../interfaces/api";
import { getApiState } from "../../../../redux/selectors/common";
import { hideModal, showModal } from "../../../../redux/slices/modal";
import { resetApiThunk } from "../../../../redux/thunks/api";
import { thunks } from '../../../../redux/thunks/thunks';
import { UpdateShopperItem } from './UpdateShopperItem';

const mapState = (state: AppState) => ({
    modal: state.modal,
    user: getApiState(state, API_KEYS.LOGIN),
    updateItemState: getApiState(state, API_KEYS.UPDATE_PERSONAL_SHOPPING_ITEM)

});

const mapDispatch = {
    showModal,
    hideModal,
    resetApi: resetApiThunk,
    updateItem : thunks.UPDATE_PERSONAL_SHOPPING_ITEM,
    getHistory : thunks.GET_PERSONAL_SHOPPING_LIST,

};

const connector = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(UpdateShopperItem);
